import { c as _c } from "react/compiler-runtime";
import { CarouselDots } from "@website/ui/carousel/carousel-dots";
import { CarouselNavigation } from "@website/ui/carousel/carousel-navigation";
import { CarouselPropertiesType } from "@website/ui/carousel/carousel.types";
import "keen-slider/keen-slider.min.css";
import { useKeenSlider } from "keen-slider/react";
import { FC, useEffect, useState } from "react";
export const CarouselV2: FC<CarouselPropertiesType> = t0 => {
  const $ = _c(36);
  const {
    sectionClassName: t1,
    options,
    list,
    keyCarousel,
    hasNavigation: t2,
    itemClass,
    hasDots,
    mode,
    rightBtnClassName,
    leftBtnClassName,
    disableArrowKeys,
    dotsNewDesign: t3,
    autoSlideInterval,
    dotsClassName
  } = t0;
  const sectionClassName = t1 === undefined ? "" : t1;
  const hasNavigation = t2 === undefined ? true : t2;
  const dotsNewDesign = t3 === undefined ? false : t3;
  const [currentSlide, setCurrentSlide] = useState(0);
  const [loaded, setLoaded] = useState(false);
  let t4;
  if ($[0] !== mode || $[1] !== options) {
    t4 = {
      initial: 0,
      rtl: true,
      renderMode: "performance",
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel);
      },
      created() {
        setLoaded(true);
      },
      ...options,
      mode
    };
    $[0] = mode;
    $[1] = options;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const [sliderReference, instanceReference] = useKeenSlider(t4);
  let t5;
  let t6;
  if ($[3] !== autoSlideInterval || $[4] !== instanceReference || $[5] !== list.length) {
    t5 = () => {
      if (!autoSlideInterval || list.length <= 1) {
        return;
      }
      const intervalId = window.setInterval(() => {
        instanceReference.current?.next();
      }, autoSlideInterval);
      return () => window.clearInterval(intervalId);
    };
    t6 = [autoSlideInterval, instanceReference, list.length];
    $[3] = autoSlideInterval;
    $[4] = instanceReference;
    $[5] = list.length;
    $[6] = t5;
    $[7] = t6;
  } else {
    t5 = $[6];
    t6 = $[7];
  }
  useEffect(t5, t6);
  const t7 = `keen-slider size-full ${sectionClassName}`;
  let t8;
  if ($[8] !== itemClass || $[9] !== keyCarousel || $[10] !== list) {
    t8 = list?.map((component, index) => <article className={`keen-slider__slide ${itemClass} !overflow-visible`} key={`${keyCarousel}-slide-${index++}`}>{component}</article>);
    $[8] = itemClass;
    $[9] = keyCarousel;
    $[10] = list;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== sliderReference || $[13] !== t7 || $[14] !== t8) {
    t9 = <section className={t7} ref={sliderReference}>{t8}</section>;
    $[12] = sliderReference;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== currentSlide || $[17] !== disableArrowKeys || $[18] !== hasNavigation || $[19] !== instanceReference || $[20] !== leftBtnClassName || $[21] !== loaded || $[22] !== rightBtnClassName) {
    t10 = Boolean(hasNavigation) && loaded && instanceReference?.current && <CarouselNavigation currentReference={instanceReference.current} currentSlide={currentSlide} disableArrowKeys={disableArrowKeys} hasNavigation={hasNavigation} leftBtnClassName={leftBtnClassName} rightBtnClassName={rightBtnClassName} />;
    $[16] = currentSlide;
    $[17] = disableArrowKeys;
    $[18] = hasNavigation;
    $[19] = instanceReference;
    $[20] = leftBtnClassName;
    $[21] = loaded;
    $[22] = rightBtnClassName;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== currentSlide || $[25] !== dotsClassName || $[26] !== dotsNewDesign || $[27] !== hasDots || $[28] !== instanceReference || $[29] !== keyCarousel || $[30] !== loaded) {
    t11 = Boolean(hasDots) && loaded && instanceReference?.current && <CarouselDots newDesign={dotsNewDesign} currentReference={instanceReference.current} currentSlide={currentSlide} dotsClassName={dotsClassName} keyCarousel={keyCarousel} />;
    $[24] = currentSlide;
    $[25] = dotsClassName;
    $[26] = dotsNewDesign;
    $[27] = hasDots;
    $[28] = instanceReference;
    $[29] = keyCarousel;
    $[30] = loaded;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t9) {
    t12 = <article className="group relative size-full">{t9}{t10}{t11}</article>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t9;
    $[35] = t12;
  } else {
    t12 = $[35];
  }
  return t12;
};